import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Report = Loadable(lazy(() => import('./Report')));

const ReportRoutes = [
	{
		path: '/report',
		element: <Report />,
		auth: authRoles.admin,
	},
];

export default ReportRoutes;
